import themeColors from '@/assets/theme/colors'

const classes = {
  mainDiv: {
    display: 'flex',
    justifyContent: 'center'
  },
  sndDiv: {
    maxWidth: 900,
    padding: '1.25rem'
  },
  h1: {
    marginTop: '2rem',
    marginBottom: '1rem',
    fontWeight: 600,
    color: themeColors.gray.dark
  },
  tagline: {
    marginBottom: '2.5rem',
    fontWeight: 600,
    lineHeight: 1.4,
    color: themeColors.bg.start
  },
  h2: {
    marginTop: '2.75rem',
    marginBottom: '1rem',
    fontWeight: 700,
    color: themeColors.gray.dark
  },
  b1: {
    fontSize: '0.95rem',
    lineHeight: 1.75,
    color: themeColors.gray.defaultText,
    marginBottom: '1rem',
    '&:last-of-type': { marginBottom: 0 }
  },
  // Each belief leads with its own claim, so the claim carries the weight.
  beliefTitle: {
    fontSize: '0.95rem',
    fontWeight: 700,
    lineHeight: 1.5,
    color: themeColors.gray.dark
  },
  beliefBox: {
    paddingLeft: '1rem',
    borderLeft: `3px solid ${themeColors.success.main}`,
    marginBottom: '1.5rem'
  },
  // The founding details sit apart from the argument above them.
  companyBox: {
    marginTop: '3rem',
    paddingTop: '1.75rem',
    borderTop: `1px solid ${themeColors.gray.lighter}`
  },
  ctaBox: {
    marginTop: '3rem',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap' as 'wrap',
    gap: '1.25rem'
  },
  ctaTitle: {
    fontWeight: 700,
    lineHeight: 1.3,
    color: themeColors.gray.dark
  }
}

export default classes
